import { actionGenerator } from '../../types/redux/actionGenerator';
export var EProfessionalUserType = /*#__PURE__*/function (EProfessionalUserType) {
  EProfessionalUserType["change"] = "registration/professionalUser/change";
  return EProfessionalUserType;
}({});
export var professionalUserChange = actionGenerator(EProfessionalUserType.change);